// extracted by mini-css-extract-plugin
module.exports = {"container":"EmbedVideoPage_container__UEyze"};